import axios from '@/libs/api.request';

export const getCurSaleDeliveryRecord = curSaleDeliveryRecordUuid => {
    return axios.request({
        url: 'api/curSaleManagement/delivery/getCurSaleDeliveryRecord',
        data: { curSaleDeliveryRecordUuid },
        method: 'post'
    });
};

export const getCurSaleDeliveryList = data => {
    return axios.request({
        url: 'api/curSaleManagement/delivery/getCurSaleDeliveryList',
        data: data,
        method: 'post'
    });
};

export const printCurSaleDeliveryRecord = curSaleDeliveryRecordUuid => {
    return axios.request({
        url: 'api/curSaleManagement/delivery/printCurSaleDeliveryRecord',
        data: { curSaleDeliveryRecordUuid },
        method: 'post'
    });
};
